import React from "react"
import { Route, Switch } from "react-router"

import App from "./App"

import Main from "./Pages/Main"
import MainByDomain from "./Pages/MainByDomain"
import Preview from "./Pages/Preview"

import NotFound from "./Pages/NotFound"

const urlBase = window.URL_BASE

const Routes = () => (
    <App>
        <Switch>
            <Route path="/" exact component={MainByDomain} />

            <Route path="/:id" exact component={Main} />
            <Route path="/:id/preview" exact component={Preview} />

            <Route path={`${urlBase}:id`} exact component={Main} />
            <Route path={`${urlBase}:id/preview`} exact component={Preview} />

            <Route component={NotFound} />
        </Switch>
    </App>
)

export default Routes
